import * as React from "react";

const SvgChevronRight = props => <svg width="100%" height="100%" viewBox="0 0 5 9" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0.951417 0L-1.08494e-09 1.0575L3.09042 4.5L-8.14862e-09 7.9425L0.951417 9L5 4.5L0.951417 0Z" fill="currentColor" /></svg>;

export default SvgChevronRight;